var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

_.extend(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

_.extend(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

_.extend(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dyb3Vwb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dyb3Vwb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxHQUFVLE9BQUEsQ0FBUSxXQUFSOztBQUNWLGdCQUFBLEdBQW1CLE9BQUEsQ0FBUSxvQkFBUjs7QUFDbkIsVUFBQSxHQUFhLE9BQUEsQ0FBUSxjQUFSOztBQUNiLE9BQUEsR0FBVSxPQUFBLENBQVEsV0FBUjs7QUFDVixXQUFBLEdBQWMsT0FBQSxDQUFRLGVBQVI7O0FBQ1osd0JBQTBCLE9BQUEsQ0FBUSxvRUFBUjs7QUFDNUIscUJBQUEsR0FBd0IsT0FBQSxDQUFRLG9CQUFSOztBQUV4QixjQUFBLEdBQWlCLE9BQUEsQ0FBUSxrQkFBUjs7QUFDakIsTUFFSSxPQUFBLENBQVEsd0JBQVIsQ0FGSixFQUFFLCtDQUFGLEVBQ0U7OztFQUlGLE1BQU0sQ0FBQyxVQUFXOzs7QUFFbEIsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFNLENBQUMsT0FBaEIsRUFBeUI7RUFDdkIsUUFBQSxFQUFVLEVBRGE7RUFFdkIsT0FBQSxFQUFTLEVBRmM7RUFHdkIsU0FBQSxFQUFXLEVBSFk7Q0FBekI7O0FBUUEsUUFBQSwwR0FBaUMsQ0FBRSxPQUF4QixDQUFBLG9CQUFBLElBQXFDLGNBQUEsSUFBa0IsTUFBdkQsSUFBaUUsTUFBTSxDQUFDLFNBQVMsQ0FBQyxjQUFsRixJQUFvRyxDQUFDLE1BQU0sQ0FBQyxhQUFQLElBQXlCLFFBQUEsWUFBb0IsYUFBOUM7O0FBQy9HLE1BQUEsR0FBWSxRQUFILEdBQ1AsWUFETyxHQUdQOztBQUVGLFVBQUEsR0FDRTtFQUFBLEdBQUEsRUFBSyxJQUFMO0VBQ0EsRUFBQSxFQUFJLElBREo7RUFFQSxJQUFBLEVBQU0sR0FGTjtFQUdBLENBQUEsRUFBRyxHQUhIO0VBSUEsQ0FBQSxFQUFHLEdBSkg7RUFLQSxDQUFBLEVBQUcsR0FMSDs7O0FBT0YsWUFBQSxHQUNFO0VBQUEsTUFBQSxFQUFRLGNBQUEsR0FBZSxVQUFVLENBQUMsR0FBMUIsR0FBOEIsS0FBdEM7RUFDQSxLQUFBLEVBQU8sY0FBQSxHQUFlLFVBQVUsQ0FBQyxFQUExQixHQUE2QixLQURwQztFQUVBLE9BQUEsRUFBUyxlQUFBLEdBQWdCLFVBQVUsQ0FBQyxJQUEzQixHQUFnQyxLQUZ6QztFQUdBLElBQUEsRUFBTSxlQUFBLEdBQWdCLFVBQVUsQ0FBQyxDQUEzQixHQUE2QixLQUhuQztFQUlBLElBQUEsRUFBTSxlQUFBLEdBQWdCLFVBQVUsQ0FBQyxDQUEzQixHQUE2QixLQUpuQztFQUtBLElBQUEsRUFBTSxlQUFBLEdBQWdCLFVBQVUsQ0FBQyxDQUEzQixHQUE2QixLQUxuQztFQU1BLE1BQUEsRUFBUSxjQUFBLEdBQWMsQ0FBQyxVQUFVLENBQUMsR0FBWCxHQUFpQixDQUFsQixDQUFkLEdBQWtDLEtBTjFDO0VBT0EsS0FBQSxFQUFPLGNBQUEsR0FBYyxDQUFDLFVBQVUsQ0FBQyxFQUFYLEdBQWdCLENBQWpCLENBQWQsR0FBaUMsS0FQeEM7RUFRQSxPQUFBLEVBQVMsZUFBQSxHQUFlLENBQUMsVUFBVSxDQUFDLElBQVgsR0FBa0IsQ0FBbkIsQ0FBZixHQUFvQyxLQVI3QztFQVNBLElBQUEsRUFBTSxlQUFBLEdBQWUsQ0FBQyxVQUFVLENBQUMsQ0FBWCxHQUFlLENBQWhCLENBQWYsR0FBaUMsS0FUdkM7RUFVQSxJQUFBLEVBQU0sZUFBQSxHQUFlLENBQUMsVUFBVSxDQUFDLENBQVgsR0FBZSxDQUFoQixDQUFmLEdBQWlDLEtBVnZDO0VBV0EsSUFBQSxFQUFNLGVBQUEsR0FBZSxDQUFDLFVBQVUsQ0FBQyxDQUFYLEdBQWUsQ0FBaEIsQ0FBZixHQUFpQyxLQVh2Qzs7OztNQWFZLENBQUMsS0FBTTs7O0FBQ3JCLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUF4QixFQUE0QjtFQUMxQixRQUFBLEVBQVUsUUFEZ0I7RUFFMUIsTUFBQSxFQUFRLE1BRmtCO0VBRzFCLFlBQUEsRUFBYyxZQUhZO0VBSTFCLFlBQUEsVUFKMEI7RUFLMUIsTUFBQSxFQUFRLEVBTGtCO0NBQTVCOzs7T0FVYyxDQUFDLFVBQVc7Ozs7T0FFWixDQUFDLFFBQVM7OztBQUV4QixDQUFDLENBQUMsTUFBRixDQUFTLE9BQU8sQ0FBQyxLQUFqQixFQUF3QjtFQUN0QixTQUFBLE9BRHNCO0VBRXRCLFNBQUEsT0FGc0I7RUFHdEIsa0JBQUEsZ0JBSHNCO0VBSXRCLGdCQUFBLGNBSnNCO0VBS3RCLHNCQUFBLG9CQUxzQjtFQU10Qiw2QkFBQSwyQkFOc0I7RUFPdEIsWUFBQSxVQVBzQjtFQVF0QixhQUFBLFdBUnNCO0VBU3RCLHVCQUFBLHFCQVRzQjtDQUF4Qjs7QUFZQSxxQkFBQSxDQUFBIn0=
